import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const Slideshow = ({ images, alt, className = "", interval = 3800, dots = true, testId }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setI((v) => (v + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId}>
      <AnimatePresence initial={false}>
        <motion.img
          key={images[i]}
          src={images[i]}
          alt={alt}
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-0 h-full w-full object-cover"
          data-testid={testId ? `${testId}-image` : undefined}
        />
      </AnimatePresence>
      {dots && images.length > 1 && (
        <div className="absolute bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-1.5">
          {images.map((_, d) => (
            <button
              key={d}
              type="button"
              aria-label={`Photo ${d + 1}`}
              onClick={(e) => { e.stopPropagation(); setI(d); }}
              data-testid={testId ? `${testId}-dot-${d}` : undefined}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                d === i ? "w-5 bg-cream" : "w-1.5 bg-cream/50 hover:bg-cream/80"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
